import React from "react";
import { MemoryRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthProvider } from "../auth/AuthContext";
import { OrganizationProvider } from "../context/OrganizationContext";
import Login from "../auth/Login";
import ProtectedRoute from "../routes/ProtectedRoute";
import RouteManager from "../routes/RouteManager";
import Dashboard from "../dashboard/Dashboard";
import OrganizationList from "../organization/OrganizationList";
import MyProfile from "../myProfile/MyProfile";

const App = () => {
  return (
    <FluentProvider theme={webLightTheme}>
      <AuthProvider>
        <OrganizationProvider>
          <Router>
            <RouteManager />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/organization-list"
                element={
                  <ProtectedRoute>
                    <OrganizationList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-profile"
                element={
                  <ProtectedRoute>
                    <MyProfile />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
          </Router>
        </OrganizationProvider>
      </AuthProvider>
    </FluentProvider>
  );
};

export default App;
